import React from 'react';
import './style.css';

function Navbar() {
    return (
        <div className="Navbar">
            Pokedex
        </div>
    );
}

export default Navbar;